import { render, staticRenderFns } from "./FavoriteModule.vue?vue&type=template&id=286bf3b6&scoped=true"
import script from "./FavoriteModule.vue?vue&type=script&lang=js"
export * from "./FavoriteModule.vue?vue&type=script&lang=js"
import style0 from "./FavoriteModule.vue?vue&type=style&index=0&id=286bf3b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bf3b6",
  null
  
)

export default component.exports